import { Overlay } from "@Light/components/page/Overlay";
import { WithHeader } from "@Light/components/page/header";
import { useHeaderRightButton } from "@Light/components/page/header/context";
import { Navigate, Route, Routes } from "react-router-dom";
import { ByZip } from "./by-zip";
import { EmailSent } from "./email-sent";
import { EnterZip } from "./enter-zip";
import { Signup } from "./signup";

export type ShopRoutesProps = {};

export const ShopRoutes: React.FC<ShopRoutesProps> = ({}) => {
  return (
    <Overlay>
      <WithHeader>
        <ShopRoutesWithinHeader />
      </WithHeader>
    </Overlay>
  );
};

export type ShopRoutesWithinHeaderProps = {};

export const ShopRoutesWithinHeader: React.FC<
  ShopRoutesWithinHeaderProps
> = ({}) => {
  useHeaderRightButton(<div />);
  return (
    <Routes>
      <Route path="/" element={<EnterZip />} />
      <Route path="/by-zip" element={<ByZip />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/email-sent" element={<EmailSent />} />
      <Route path="/*" element={<Navigate to="/" />} />
    </Routes>
  );
};
